// Token management
const TOKEN_KEY = 'at';
let currentToken = null;

export function getToken() {
  if (currentToken) {
    return currentToken;
  }

  if (window.localStorage) {
    return window.localStorage.getItem(TOKEN_KEY);
  }

  return null;
}

export function setToken(token: string) {
  if (window.localStorage) {
    if (token) {
      window.localStorage.setItem(TOKEN_KEY, token);
    } else {
      window.localStorage.removeItem(TOKEN_KEY);
    }
  }

  currentToken = token;
}
